import { render, staticRenderFns } from "./immediately.vue?vue&type=template&id=6d76248f&scoped=true"
import script from "./immediately.vue?vue&type=script&lang=js"
export * from "./immediately.vue?vue&type=script&lang=js"
import style0 from "./immediately.vue?vue&type=style&index=0&id=6d76248f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d76248f",
  null
  
)

export default component.exports